import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "題目",
    isNumber: true,
    isSum: true,
    isControl: true,
  },
  {
    key: "選項",
    isNumber: true,
  },
];

const groupOrders = {
  年齡層: {
    "<65": 0,
    "65-69": 1,
    "70-74": 2,
    "75-79": 3,
    "80-84": 4,
    ">=85": 5,
  },
};

export const HealthCenterHealthCheckupAnalysisAge = {
  label: "衛生所健檢分析(年齡)",
  key: "HealthCenterHealthCheckupAnalysisAge",
  path: "HealthCenterHealthCheckup/HealthCenterHealthCheckupAnalysisAge",
  api: "TCS_V_HCCS01",
  render: (options) => (
    <Diagram.HealthCenterHealthCheckup.HealthCenterHealthCheckupAnalysisAge
      {...options}
    />
  ),
  isGroup: true,
  isPercent: true,
  isColSum: true,
  isRowSum: true,
  groupColumns: [
    {
      key: "年齡層",
      field: "年齡層",
      header: "",
    },
  ],
  groupOrders,
  filterColumns: [
    { key: "填表次序", type: "string" },
    { key: "性別", type: "string" },
    { key: "縣市", type: "string" },
    { key: "鄉鎮", type: "string" },
    { key: "衛生所", type: "string" },
  ],
  levelColumns,
  columns: [],
};
